import { EditedTask } from "@/types";
import isEqual from "lodash.isequal";
import { MutableRefObject, useEffect } from "react";

const useSaveAllowed = (
  editedTask: EditedTask | null,
  selectedEditableTask: EditedTask | null,
  saveAllowed: MutableRefObject<boolean>
) => {
  useEffect(() => {
    if (editedTask && selectedEditableTask) {
      // Title Check
      if (editedTask.title && !editedTask.title.trim()) {
        saveAllowed.current = false;
        return;
      }
      if (!isEqual(selectedEditableTask, editedTask)) {
        console.log("Setting save allowed to true");
        saveAllowed.current = true;
      } else {
        saveAllowed.current = false;
      }
    }
  }, [editedTask, selectedEditableTask, saveAllowed]);
};

export default useSaveAllowed;
